
<template lang="pug">
DropGuard
  q-page.fit.importcsv
    .q-px-md.row.justify-around(v-if="status")
      .q-px-sm.q-py-lg.column.items-center
        DropFile.q-my-md(@drop="onDrop('stores', ...arguments)")
          .importcsv__dropzone
            div 店舗マスター {{status.stores.count}}件
            div POST {{getUrl('import/stores')}}
            div ここにcsvファイルをドロップしてください

        DropFile.q-my-md(@drop="onDrop('people', ...arguments)")
          .importcsv__dropzone
            div 個人マスター {{status.people.count}}件 ({{status.people.storeCount}}店舗分)
            div POST {{getUrl('import/people')}}
            div ここにcsvファイルをドロップしてください

        DropFile.q-my-md(@drop="onDrop('tasks', ...arguments)")
          .importcsv__dropzone
            div レジマスター {{status.tasks.count}}件 ({{status.tasks.storeCount}}店舗分)
            div POST {{getUrl('import/tasks')}}
            div ここにcsvファイルをドロップしてください

        DropFile.q-my-md(@drop="onDrop('results', ...arguments)")
          .importcsv__dropzone
            div 実績客数データ {{status.results.count}}件 ({{status.results.storeCount}}店舗分,{{status.results.dateCount}}日分)
            div {{status.results.dateMin}}〜{{status.results.dateMax}}
            div POST {{getUrl('import/results')}}
            div ここにcsvファイルをドロップしてください

        DropFile.q-my-md(@drop="onDrop('estimates', ...arguments)")
          .importcsv__dropzone
            div 予測客数データ {{status.estimates.count}}件 ({{status.estimates.storeCount}}店舗分,{{status.estimates.dateCount}}日分)
            div {{status.estimates.dateMin}}〜{{status.estimates.dateMax}}
            div POST {{getUrl('import/estimates')}}
            div ここにcsvファイルをドロップしてください

        div これらのAPIはcookieを使用する認証により保護されています。
        div {{getUrl('login')}}
        div 上記urlにusernameとpasswordをPOSTし、
        div レスポンスで受け取るcookieをAPIアクセスに含めてください。

        q-btn.q-my-md(
          v-if="$store.state.config.app_debug"
          color="negative"
          @click="onTruncate"
        ) データベースを初期化する

      .q-px-sm.q-py-lg.column.items-center
        table
          thead
            tr
              th 日時
              th IP
              th 対象
              th 結果
          tbody
            tr(v-for="log of logs_")
              td {{log.date}}
              td {{log.ip}}
              td {{log.target}}
              td {{log.result}}
</template>

<script>
import {mapActions} from 'vuex'

import DropGuard from 'components/DropGuard'
import DropFile from 'components/DropFile'
import AxiosMixin from 'mixins/axios'

export default {
  components: {DropGuard, DropFile},
  mixins: [AxiosMixin],

  data() {
    return {
      status: null,
    }
  },

  computed: {
    logs_() {
      return this.status.logs.slice(-20).reverse()
    },
  },

  async mounted() {
    await this.first()
  },

  methods: {
    ...mapActions(['fetchConfig']),

    getUrl: name => new URL('/api/' + name, window.location.href).href,

    async first() {
      try {
        const {data} = await this.axios.get('/api/import/status')
        this.status = data
      }
      catch(e) {this.$handler(e)}
    },

    async refresh() {
      try {
        const [{data}] = await Promise.all([
          this.axios.get('/api/import/status'),
          this.fetchConfig(),
        ])
        this.status = data
      }
      catch(e) {this.$handler(e)}
    },

    async onDrop(name, files) {
      try {
        if(files.length !== 1) {
          this.$notify('ファイルは1つだけにしてください')
          return
        }

        const file = files[0]

        if(file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') {
          this.$notify('csvファイルをドロップしてください')
          return
        }

        const fileRead = async file => new Promise((resolve, reject) => {
          const fileReader = new FileReader
          fileReader.onerror = () => {
            fileReader.abort()
            this.$notify('ファイルが読み込めませんでした')
            reject(new Error)
          }
          fileReader.onload = () => {
            resolve(fileReader.result)
          }
          fileReader.readAsArrayBuffer(file)
        })
        const fileContent = await fileRead(files[0])

        const {data} = await this.axios.post(this.getUrl('import/' + name), fileContent, {headers: {'Content-Type': 'text/csv'}})

        let message = '成功！ 読込 ' + data.importCount + '件、 追加 ' + data.createCount + '件、更新 ' + data.updateCount + '件'
        if('deleteCount' in data) {
          message += '、削除 ' + data.deleteCount + '件'
        }
        this.$notify({message, type: 'positive'})
      }
      catch(e) {this.$handler(e)}
      finally {await this.refresh()}
    },

    async onTruncate() {
      try {
        await this.$q.dialog({
          title:   'データベースの初期化の確認',
          message: 'これらのテーブルがすべて0件になります。本当によろしいですか？',
          ok:      {label: '実行',       color: 'negative'},
          cancel:  {label: 'キャンセル', color: 'dark', flat: true},
        })

        await this.axios.delete('/api/import/truncate')

        await this.refresh()

        await this.$q.dialog({
          title:   '完了',
          message: 'すべてのデータを初期化しました',
        })
      }
      catch(e) {this.$handler(e)}
    },
  },
}
</script>

<style lang="sass">
.importcsv
  font-size: 90%

.importcsv__dropzone
  border: 2px solid lightgray
  border-radius: 8px
  padding: 16px 48px
  text-align: center
</style>
